export default __webpack_public_path__ + "static/media/beetroot.fb58d823.png";